import { render, staticRenderFns } from "./LichSuVanTaiKhachList.vue?vue&type=template&id=5cf1d738"
import script from "./LichSuVanTaiKhachList.vue?vue&type=script&lang=js"
export * from "./LichSuVanTaiKhachList.vue?vue&type=script&lang=js"
import style0 from "./LichSuVanTaiKhachList.vue?vue&type=style&index=0&id=5cf1d738&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports